export default __webpack_public_path__ + "static/img-channel-heading-4376ea3a4d663a7b378169c7c55680dd.avif";